import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { ProjectIcon } from '@/components/icons/ProjectIcon';
import type { WorkspaceGlobalSearchBarResultProject } from '@/types';
import { cx } from '@trinity/chat-components';
import ClickContainer from './Results.ClickContainer';
import styles from './style/Results.Project.module.css';

export default function ResultsProject({ className, index, item, highlighted }: ResultsProjectProps) {
  return (
    <ClickContainer index={index} item={item}>
      <div className={cx(styles.root, { [styles.highlighted]: highlighted }, className)}>
        <ProjectIcon
          className={styles.icon}
          projectTypeId={item.metadata.type} />
        <div className={styles.details}>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.type}>Project</div>
        </div>
        {highlighted && (
          <div className={styles.return}>
            <KeyboardReturnIcon />
          </div>
        )}
      </div>
    </ClickContainer>
  );
}

export { ResultsProject };

type ResultsProjectProps = {
  className?: string;
  index: number;
  item: WorkspaceGlobalSearchBarResultProject;
  highlighted?: boolean;
};